import { Component, OnInit } from '@angular/core';
import { faChevronRight, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { RefreshComponent } from 'src/app/core/grid-renderer/refresh/refresh.component';
import { ConnectionsService } from 'src/app/services/connections.service';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { ActivatedRoute } from '@angular/router';
import { EventService } from 'src/app/services/event.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from '../../core/constant/common.constant';
import { HistoryDetailService } from 'src/app/services/history-detail.service';
import { Constants } from 'src/app/constants';
import { DatePipe } from '@angular/common';
import { ExcelService } from 'src/app/services/excel.service';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-connections',
  templateUrl: './connections.component.html',
  styleUrls: ['./connections.component.scss'],
  standalone: false // NOSONAR
})
export class ConnectionsComponent implements OnInit {
  name: any;
  loadDataRD() {
    throw new Error('Method not implemented.');
  }
  exporttoExcel() {
    throw new Error('Method not implemented.');
  }

  menuVariable: boolean = false;
  faChevronRight = faChevronRight;
  faFileExcel = faFileExcel;
  gridOptions: any;
  openMenu() {
    this.menuVariable = !this.menuVariable;
  }

  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 20;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  connect: boolean = true;
  errorMessage: any;
  successMessage: any;
  eventId: string;
  eventData: any;
  eventType: any;
  plannedUnload: string;
  eventRegion: string;
  eventRoute: string;
  eventEta: string;
  eventStatus: string;
  reOpen: boolean;

  constructor(private readonly dialog: MatDialog,
    private readonly eventService: EventService,
    public readonly history: HistoryDetailService,
    private readonly connectionsService: ConnectionsService,
    private readonly route: ActivatedRoute,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly excelService: ExcelService,
    private readonly constants: Constants) {
    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true
    }
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">'
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',           // NOSONAR
    };
  }

  ngOnInit(): void {
    this.eventStatus = '';
    this.reOpen = false;
    this.eventId = '';
    this.eventType = '';
    this.plannedUnload = '';
    this.eventRegion = '';
    this.eventRoute = '';
    this.eventEta = '';

    if (localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }
    this.loadEventData();


    this.columnDefs = [
      {
        floatingFilterComponent: RefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true }, minWidth: 30, maxWidth: 40
      },
      {
        headerName: "IMPACTED", field: "is_impacted", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "CURRENT ROUTE", field: "current_route", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 105, maxWidth: 130,
      },
      {
        headerName: "SUPPLIER", field: "supplier_id", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "CA CODE", field: "ca_code", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "MTM CODE", field: "mtm_code", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 120, maxWidth: 130,
      },
      {
        headerName: "PLANT", field: "plant_id", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "DOCK", field: "logical_dock_id", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "ORDER", field: "order_number", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "ROUTE 1", field: "route_1", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "REGION", field: "route_1_region", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "CD1 U/L", field: "route_1_unload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "ROUTE 2", field: "route_2", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "REGION", field: "route_2_region", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "CD1 R/L", field: "route_1_reload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "CD2 U/L", field: "route_2_unload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "ROUTE 3", field: "route_3", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "REGION", field: "route_3_region", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "CD2 R/L", field: "route_2_reload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "CD3 U/L", field: "route_3_unload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "ROUTE 4", field: "route_4", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "REGION", field: "route_4_region", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "CD3 R/L", field: "route_3_reload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "CD4 U/L", field: "route_4_unload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "PLANT U/L", field: "plant_unload", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, maxWidth: 135,
        comparator: this.dateComparator,
      },

    ]
  }

  loadEventData() {
    this.successMessage = null;
    this.errorMessage = null;
    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    let upn = fgaDetails?.user?.userPrincipalName;
    let roles = fgaDetails?.roles?.map(r => r.displayName);
    let lpCodes = this.getUserAttribute('additionalLpCode')  ?.split(',')  ?.map(code => code.trim()) || [];
      console.log(lpCodes);
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const fromDashboard = this.route.snapshot.pathFromRoot.flatMap((val) => val.url.join('')).join('/').includes('dashboard');
    const data = {
      eventId: this.eventId,
      pageNo: fromDashboard ? '0' : '1',
      pageSize: '50'
    };
    this.eventService.getEventDetails(data, upn,roles,lpCodes).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.eventData = res;
        this.eventType = this.findEventType(this.eventData.editEvent.eventTypeId, this.eventData.eventTypeList, 'eventTypeId');
        this.plannedUnload = this.etaFormat(this.eventData.editEvent.arrival);
        this.eventRegion = this.findRegionDescription(this.eventData.editEvent.region, this.eventData.regionList);
        this.eventRoute = this.eventData.editEvent.puRoute;
        this.eventEta = this.etaFormat(this.eventData.editEvent.eta);
        this.eventStatus = this.findEventType(this.eventData.editEvent.statusId, this.eventData.eventStatuses, 'statusId');
        if (this.eventStatus == 'Closed') { // NOSONAR
          this.reOpen = false;
        } else {
          this.reOpen = true;
        }
        if (res.connectionSize > 0) {
          this.apiCall();
        }
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);

      }
    })
  }


  	  
	  
  getUserAttribute(key: string): any {

    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));

    return fgaDetails?.user?.applicationUserAttribute
      ?.flatMap(app => app.userAttributes)
      ?.find(attr => attr.key === key)
      ?.value;
  }	
  findEventType(id, data, name) {
    for (let i = 0; i < data.length; i++) {

      if (data[i][name] == id) { // NOSONAR
        return data[i].description;
      }
    }
    return "";
  }

  date_format = 'MM/DD/YYYY HH:mm'
  etaFormat(date) {
    if (date) {
      const value = moment(date).format(this.date_format);
      return value;
    } else {
      return "";
    }
  }

  findRegionDescription(regionCode, regionList) {

    for (let i = 0; i < regionList.length; i++) {
      if (regionList[i].itemCode == regionCode) { // NOSONAR
        return regionList[i].itemDesc;
      }
    }
    return "";
  }
  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }
  dateFormatter(res) {

    if (res == null) { return ''; } // NOSONAR

    else { return moment.utc(res).format(this.date_format); }

  }
  apiCall() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const data = {
      eventId: this.eventId,
      pageNo: '1',
      pageSize: '50'
    }
    this.connectionsService.getConnections(data).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.displayRowData = res.map((element: any) => {
          let impactedStatus = '';

          if (element.is_impacted == '1') { // NOSONAR
            impactedStatus = 'Impacted';
          } else if (element.is_impacted == '0') { // NOSONAR
            impactedStatus = 'OK';
          }
          return {
            ...element,
            is_impacted: impactedStatus,
            route_1_unload: this.dateFormatter(element.route_1_unload),
            route_1_reload: this.dateFormatter(element.route_1_reload),
            route_2_unload: this.dateFormatter(element.route_2_unload),
            route_2_reload: this.dateFormatter(element.route_2_reload),
            route_3_unload: this.dateFormatter(element.route_3_unload),
            route_3_reload: this.dateFormatter(element.route_3_reload),
            route_4_unload: this.dateFormatter(element.route_4_unload),
            plant_unload: this.dateFormatter(element.plant_unload),

          }
        });
        this.rowCount = this.displayRowData.length;

      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    })
  }
  sizeToFit() { this.gridApi?.sizeColumnsToFit() };

  onGridReady(params: any) {
    this.gridApi = params.api

    this.gridApi.applyTransaction({ add: this.displayRowData });
  }


  downloadConnections() {

    const headers = [
      'IMPACTED',
      'CURRENT ROUTE',
      'SUPPLIER',
      'CA CODE',
      'MTM CODE',
      'PLANT',
      'DOCK',
      'ORDER',
      'ROUTE 1',
      'REGION',
      'CD1 U/L',
      'ROUTE 2',
      'REGION',
      'CD1 R/L',
      'CD2 U/L',
      'ROUTE 3',
      'REGION',
      'CD2 R/L',
      'CD3 U/L',
      'ROUTE 4',
      'REGION',
      'CD3 R/L',
      'CD4 U/L',
      'PLANT U/L',
    ];
    const exportData = [];
    this.displayRowData.forEach((e) => {
      const obj = {
        IMPACTED: (e.is_impacted == "1" ? "Impacted" : "OK"), // NOSONAR
        CURRENT_ROUTE: e.current_route,
        SUPPLIER: e.supplier_id,
        CA_CODE: e.ca_code,
        MTM_CODE: e.mtm_code,
        PLANT: e.plant_id,
        DOCK: e.logical_dock_id,
        ORDER: e.order_number,
        ROUTE: e.route_1,
        REGION: e.route_1_region,
        CD1_UL: (e.route_1_unload) ? moment.utc(e.route_1_unload).format(this.date_format) : "",
        ROUTE2: e.route_2,
        REGION2: e.route_2_region,
        CD1_RL: (e.route_1_reload) ? moment.utc(e.route_1_reload).format(this.date_format) : "",
        CD2UL: (e.route_2_unload) ? moment.utc(e.route_2_unload).format(this.date_format) : "",
        ROUTE3: e.route_3,
        REGION3: e.route_3_region,
        CD2RL: (e.route_2_reload) ? moment.utc(e.route_2_reload).format(this.date_format) : "",
        CD3UL: (e.route_3_unload) ? moment.utc(e.route_3_unload).format(this.date_format) : "",
        ROUTE4: e.route_4,
        REGION4: e.route_4_region,
        CD3_RL: (e.route_3_reload) ? moment.utc(e.route_3_reload).format(this.date_format) : "",
        CD4_UL: (e.route_4_unload) ? moment.utc(e.route_4_unload).format(this.date_format) : "",
        PLANT_UL: (e.plant_unload) ? moment.utc(e.plant_unload).format(this.date_format) : "",

      };

      exportData.push(obj);
    });
    this.excelService.exportAsExcelFile(exportData, 'getDetailedConnections', headers);
  }

  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if (this.rowCount == 0 && Number(check) == 0) { // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML = '0';
    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else {
      this.currentPageBoolean = false;

    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {// NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.paginationPageSize = event.target.value;

    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }



}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}

